// ============================================================================
// marketRoles.ts — РОЛИ маркетплейса (чистая логика без React).
//
// Источник ролей — JWT/сессия (authStore). Здесь только нормализация и решение
// «оператор/админ»: используется экранами (useMarketOperator) И слоем данных
// (lib/marketDispute — гейт решения по спору), без дублей правил.
// ============================================================================

const ADMIN_ROLES = new Set(['admin', 'global:admin', 'администратор']);
const OPERATOR_ROLES = new Set([
  'оператор маркетплейса',
  'оператормаркетплейса',
  'market_operator',
]);

function normalizeRole(value: unknown): string {
  return String(value ?? '').trim().toLowerCase();
}

export interface MarketOperatorAccess {
  isAdmin: boolean;
  isOperator: boolean;
  /** Все роли пользователя (нормализованные) — для диагностики/подписей. */
  roles: string[];
}

export function marketOperatorAccess(rolesInput: unknown): MarketOperatorAccess {
  const roles = (Array.isArray(rolesInput) ? rolesInput : []).map(normalizeRole).filter(Boolean);
  const isAdmin = roles.some((r) => ADMIN_ROLES.has(r));
  const isOperator = isAdmin || roles.some((r) => OPERATOR_ROLES.has(r));
  return { isAdmin, isOperator, roles };
}
